<template>
  <!--  // 教师理论课统计 -->
  <div class="teacher_theory_wrap">
    <div class="class_number_statistics" v-if="true">
      <h2>班级人数<span>{{overallProgressData.studentNum}}</span>在学人数<span>{{overallProgressData.studyNum}}</span>未学人数<span>{{overallProgressData.noStudyNum}}</span></h2>
      <div class="class_number_statistics_main">
        <div class="overall_progress">
          <el-progress type="circle" :percentage="overallProgressData.progress" color="#34D3B0"></el-progress>
          <p>整体课程进度 <span @click="viewClassProgress">查看详情<i></i></span></p>
        </div>
        <div class="classify_progress" v-if="resourceData.length>0">
          <div class="progress_diagram" v-for="(item,i) in resourceData" :key="i">
            <el-progress type="circle" :percentage="item.progress?item.progress:0"></el-progress>
            <p>{{item.resourceType | typeStatus}}类任务进度</p>
          </div>
        </div>
      </div>
    </div>
    <div class="class_number_statistics_single" v-else>
      <h2>班级人数<span>60</span>在学人数<span>45</span>未学人数<span>15</span></h2>
      <div class="overall_course_progress">
        <span>整体课程进度</span>
        <div style="width: 80%;float:left;margin: 15px 0 0 20px;">
          <el-progress :show-text="true" :stroke-width="6" :percentage="70"></el-progress>
        </div>
      </div>
      <el-button @click="viewClassProgress">查看详情</el-button>
    </div>
    <div>
      <div class="recent_learning_num" style="width:100%">
        <h2>最近学习人数
          <!-- <span>今日学习人数<i>22</i></span> -
          <span>日均学习人数<i>22</i></span> -->
        </h2>
        <div class="broken_line_diagram">
          <p @click="tabLearnType">
            <b :class="learnType==7?'active':''">周</b>
            <b :class="learnType==30?'active':''">月</b>
          </p>
          <ve-line
           :data="learnChartData"
           :settings="chartSettings"
           :extend="peopleExtend"
           width="98%"
           height="350px"
           :legend-visible="false"
           :colors="colors"></ve-line>
        </div>
      </div>
      <div class="learning_hours_today" v-if="false">
        <el-tabs v-model="activeName" @tab-click="handleClick" :stretch="true">
          <el-tab-pane label="今日学习时长排行" name="first">
            <p class="prompting_language">（包括视频、音频、文档、图片类学习时长）</p>
            <ul class="ranking_list">
              <li>
                <span><img src="../../../../../../../static/images/study/statistics/first.png" alt=""></span>
                <span>1</span>
                <span>张三</span>
                <span>10小时24分钟</span>
              </li>
              <li>
                <span><img src="../../../../../../../static/images/study/statistics/second.png" alt=""></span>
                <span>2</span>
                <span>张三</span>
                <span>10小时24分钟</span>
              </li>
              <li>
                <span><img src="../../../../../../../static/images/study/statistics/third.png" alt=""></span>
                <span>3</span>
                <span>张三</span>
                <span>10小时24分钟</span>
              </li>
              <li>
                <span><img src="" alt=""></span>
                <span>4</span>
                <span>张三</span>
                <span>10小时24分钟</span>
              </li>
              <li>
                <span><img src="" alt=""></span>
                <span>5</span>
                <span>张三</span>
                <span>10小时24分钟</span>
              </li>
            </ul>
            <p class="view_more" @click="viewLearningDuration">查看更多</p>
          </el-tab-pane>
          <el-tab-pane label="总学习时长排行" name="second">总学习时长排行</el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div style="clear: both;"></div>
    <!-- <div v-if="deptId=='506'"> -->
<!--    <div class="study_length_statistics">-->
<!--      <h2>学习时长统计</h2>-->
<!--      <div class="histogram_statistics" v-if="studyLengthData.rows.length>0">-->
<!--        <ve-histogram-->
<!--         :extend="studyLengthExtend" -->
<!--         :data="studyLengthData" -->
<!--         :data-zoom="studyLengthDataZoom"-->
<!--         :legend-visible="false"-->
<!--         width="96%" -->
<!--         height="320px"></ve-histogram>-->
<!--      </div>-->
<!--      <div v-else class="no_data">-->
<!--        <img src="../../../../../../../static/images/wujieguo.png" alt="">-->
<!--        <p>暂无统计结果</p>-->
<!--      </div>-->
<!--    </div>-->
    <div class="discuss_statistics">
      <h2>讨论</h2>
      <div class="class_discuss">
        <div class="class_discuss_title">
          <h3>班级 <span @click="viewClassDiscuss">查看详情<i></i></span></h3>
          <!-- <p>今日：发起主题数 <span>{{discussData.today_theme}}</span>条 - 回复数 <span>{{discussData.today_reply}}</span>条 - 评论数 <span>{{discussData.today_comment}}</span>条</p> -->
        </div>
        <div class="class_discuss_progress">
          <el-progress type="circle" :percentage="discussData.departDegress" color="#34D3B0"></el-progress>
          <p>讨论参与度</p>
        </div>
        <ul class="class_discuss_details">
          <li>
            <p><span>{{discussData.theme_reply_comment_num}}</span>条</p>
            <p>主题、回复及评论总数</p>
          </li>
          <li>
            <div class="lis_left">
              <p><span>{{discussData.theme_num}}</span>条</p>
              <p>主题数</p>
            </div>
            <div class="lis_right">
              <p>老师答疑区主题：<span>{{discussData.teacher_theme_num}}</span>条</p>
              <p>课堂交流区主题：<span>{{discussData.student_theme_num}}</span>条</p>
            </div>
          </li>
          <li>
            <p><span>{{discussData.reply_comment_num}}</span>条</p>
            <p>回复和评论数</p>
          </li>
        </ul>
      </div>
      <div class="personal_discuss">
        <h3>个人</h3>
        <ul>
          <li>
            <p><span>{{personalDiscuss.pubThemeNum}}</span>条</p>
            <p>发布主题数</p>
          </li>
          <li>
            <el-progress type="circle" :percentage="personalDiscuss.replyDegree" color="#FFB23C"></el-progress>
            <p>主题回复率（{{personalDiscuss.replyNum}}/{{personalDiscuss.totalReplyNum}}）</p>
          </li>
          <li>
            <el-progress type="circle" :percentage="personalDiscuss.departDegree" color="#5397F7"></el-progress>
            <p>主题参与率（{{personalDiscuss.departNum}}/{{personalDiscuss.totalDepartNum}}）</p>
          </li>
        </ul>
      </div>
    </div>
    <div v-if="isTestData" class="last_wrap">
      <div class="student_open_notes" :style="'height:'+testHeight+'px'">
        <h2>学生公开笔记</h2>
        <ul>
          <!-- <li>
            <p><span>{{noteData.todayNum}}</span>条</p>
            <p>今日公开笔记数</p>
            <img src="../../../../../../../static/images/study/statistics/arrow.png" alt="" @click="viewPublicNotes('first')">
          </li> -->
          <li>
            <p><span>{{noteData.totalNum}}</span>条</p>
            <p>公开笔记总数</p>
            <img src="../../../../../../../static/images/study/statistics/arrow.png" alt="" @click="viewPublicNotes('second')">
          </li>
        </ul>
      </div>
      <div class="test_statistics_wrap" id="test_statistics_wrap">
        <div class="test_statistics_diagram">
          <h2>测验</h2>
          <div class="broken_line_diagram" v-if="testChartData.rows.length>1">
            <ve-line
              :data="testChartData"
              :extend="testExtend"
              :colors="testColors"
              :data-empty="testDataEmpty"
              width="96%"
              height="350px">
            </ve-line>
          </div>
          <div class="single_test_diagram" v-else>
            <!-- <span class="view_details">查看详情<i></i></span> -->
            <div>
              <p>{{singleTestData.paperName}}</p>
              <p>完成率<span>{{singleTestData.progress}}%</span>（提交{{singleTestData.num}}人/共{{singleTestData.studentNum}}人）</p>
            </div>
            <ul>
              <li>
                <el-progress type="circle" :percentage="singleTestData.maxScore" color="#FF6464"></el-progress>
                <span>{{singleTestData.maxScore}}分</span>
                <p>班级最高分</p>
              </li>
              <li>
                <el-progress type="circle" :percentage="singleTestData.avgScore" color="#B95AFF"></el-progress>
                <span>{{singleTestData.avgScore}}分</span>
                <p>班级平均分</p>
              </li>
            </ul>
          </div>
        </div>
        <div class="test_statistics_list" v-if="testChartData.rows.length>1">
          <h2>排名</h2>
          <ul>
            <li v-for="(item,i) in testDataList" :key="i">
                <p>{{item.progress}}%完成率</p>
                <p :title="item.paperName">{{item.paperName}}</p>
                <p>( 提交{{item.num}}人/共{{item.studentNum}}人 )</p>
              <!-- <img src="../../../../../../../static/images/study/statistics/arrow.png" alt="" @click="testJump(item)"> -->
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="student_open_notes_transverse">
        <h2>学生公开笔记</h2>
        <ul>
          <!-- <li>
            <p><span>{{noteData.todayNum}}</span>条</p>
            <p>今日公开笔记数</p>
            <img src="../../../../../../../static/images/study/statistics/arrow.png" alt="" @click="viewPublicNotes('first')">
          </li> -->
          <li>
            <p><span>{{noteData.totalNum}}</span>条</p>
            <p>公开笔记总数</p>
            <img src="../../../../../../../static/images/study/statistics/arrow.png" alt="" @click="viewPublicNotes('second')">
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
  /*
   *  教师理论课统计
   *  author: wjl
   */
import * as api from '../../../../../../api/statisticsApi'
export default {
  data() {
    this.chartSettings = {
      stack: { '用户': ['访问人数'] },
      area: true,
      itemStyle:{ //面积图颜色设置
        color:{
          type:'linear',
          x:0,
          y:0,
          x2:0,
          y2:1,
          colorStops:[
            {
              offset: 0,
              color: 'rgba(83,151,247,0.8)', // 0% 处的颜色
            },
            {
              offset: 1,
              color: 'rgba(255,255,255,1)' // 100% 处的颜色
            },
          ],
          globalCoord: false
        }
      },
    }
    this.peopleExtend = {
      series: {
        label: {
          normal: {
            show: true
          }
        }
      }
    }
    this.testExtend = {
      yAxis: {
        type: 'value',
        max: 100,
        min: 0
      },
      series: {
        label: {
          normal: {
            show: true
          }
        }
      }
    }
    return {
      courseId: this.$route.query.id,
      classId: this.$route.query.classId,
      overallProgressData: { //班级人数及进度
        progress: 0,
        studentNum: 0,
        studyNum: 0,
        noStudyNum: 0,
      },
      resourceData: [],//资源进度
      learnChartData: { //最近学习人数
        columns: ['时间', '访问人数'],
        rows: []
      },
      colors: ['#5397F7'],
      learnType: 7,
      activeName: 'first',
      discussData: {//班级讨论
        departDegress: 0,
        reply_comment_num: 0,
        theme_num: 0,
        theme_reply_comment_num: 0,
        teacher_theme_num: 0,
        student_theme_num: 0,
        today_theme: 0,
        today_reply: 0,
        today_comment: 0
      },
      personalDiscuss: {//个人讨论
        pubThemeNum: 0,
        replyDegree: 0,
        replyNum: 0,
        totalReplyNum: 0,
        departDegree: 0,
        departNum: 0,
        totalDepartNum: 0
      },
      noteData: {
        todayNum: 0,
        totalNum: 0
      },
      testDataEmpty: false,
      isTestData: false,
      testChartData: {
        columns: ['名称', '班级最高分', '班级平均分'],
        rows: []
      },
      testColors: ['#FF6464','#B95AFF'],
      singleTestData: {// 单个测验数据
        paperName: '',
        progress: 0,
        num: 0,
        studentNum: 0,
        maxScore: 0,
        avgScore: 0
      },
      testDataList: [],
      testHeight: '',
      deptId: sessionStorage.getItem('deptId'),
      studyLengthData: {//学习时长统计数据-柱状图
        columns: ['name', 'weights'],
        rows: []
      },
      studyLengthList: [],//学习时长统计-划过
      studyLengthExtend: null,
      studyLengthDataZoom: null,
    }
  },
  filters: {
    typeStatus(type) {
      switch (type) {
        case 1:
          return "图片";
        case 2:
          return "文档";
        case 3:
          return "音频";
        case 4:
          return "视频";
        case 5:
          return "zip";
        case 6:
          return "实操";
        case 7:
          return "测验";
        case 8:
          return "笔记";
        case 9:
          return "发布讨论";
        case 10:
          return "回复讨论";
        case 11:
          return "评论讨论";
        default:
          return "实操";
          break;
      }
    }
  },
  mounted(){
    this.init()
  },
  methods: {
    init(){
      this.getPeopleNum() //班级人数
      this.getCourseProgress() //课程进度
      this.getSourceProgress() //资源分类进度
      this.getRecentLearningNum() //最近学习人数
      // this.getStudyLength() //学习时长统计
      this.getDiscussData() //班级讨论
      this.getOwnDiscussData() //个人讨论
      this.getNoteData() //公开笔记
      this.getTestData() //测验折线图
      this.$nextTick(function () {
        this.testHeight = document.getElementById('test_statistics_wrap')?document.getElementById('test_statistics_wrap').clientHeight:0
      })
    },
    handleClick(tab, event) {
      // console.log(tab, event);
    },
    viewClassProgress(){//查看班级进度
      let that = this
      this.$router.push({
        path:'/switch/statistics/classProgress',
        query: {
          id: that.$route.query.id,
          classId: that.$route.query.classId,
          className: that.$route.query.className
        }
      })
    },
    viewLearningDuration(){//查看学习时长
      let that = this
      this.$router.push({
        path:'/switch/statistics/learningDuration',
        query: {
          id: that.$route.query.id,
          classId: that.$route.query.classId,
          className: that.$route.query.className
        }
      })
    },
    viewClassDiscuss(){//查看班级讨论
      let that = this
      this.$router.push({
        path:'/switch/statistics/classDiscuss',
        query: {
          id: that.$route.query.id,
          classId: that.$route.query.classId,
          className: that.$route.query.className
        }
      })
    },
    viewPublicNotes(flag){//查看公开笔记
      let that = this
      this.$router.push({
        // path:'/switch/statistics/publicNotes',
        path:'/switch/statistics/publicNoteList',
        query: {
          id: that.$route.query.id,
          classId: that.$route.query.classId,
          className: that.$route.query.className,
          // flag: flag
        }
      })
    },
    getPeopleNum(){//班级人数
      api.getClassNum(this.courseId,this.classId).then(rs=>{
        if(rs.code==0){
          this.overallProgressData.studentNum = rs.data.studentNum
          this.overallProgressData.studyNum = rs.data.studyNum
          this.overallProgressData.noStudyNum = rs.data.noStudyNum
        }else{
          this.$messageError(rs.msg)
        }
      })
    },
    getCourseProgress(){//课程进度
      api.getClassProgress(this.courseId,this.classId).then(rs=>{
        if(rs.code==0){
          this.overallProgressData.progress = rs.data
        }else{
          this.$messageError(rs.msg)
        }
      })
    },
    getSourceProgress(){//资源进度
      api.getSourceProgress(this.courseId,this.classId).then(rs=>{
        if(rs.code==0){
          this.resourceData = rs.data
        }else{
          this.$messageError(rs.msg)
        }
      })
    },
    getRecentLearningNum(){//最近学习人数
      let obj = {
        "classId": this.classId,
        "courseId": this.courseId,
        "type": this.learnType
      }
      api.getLearningNum(obj).then(rs=>{
        if(rs.code==0){
          this.learnChartData.rows = []
          rs.data.list.forEach(v=>{
            let obj = { '时间': v.time, '访问人数': v.num }
            this.learnChartData.rows.push(obj)
          })
        }else{
          this.$messageError(rs.msg)
        }
      })
    },
    getStudyLength(){//学习时长统计
      let that = this
      this.studyLengthData.rows = []
      let data = [
        // {name: '张三1', time: '30'},
        // {name: '张三2', time: '76'},
        // {name: '张三3', time: '25'},
        // {name: '张三4', time: '81'},
        // {name: '张三5', time: '48'},
      ]
      data.forEach((v)=>{
        let obj = {'name': v.name, 'weights': v.time}
        this.studyLengthData.rows.push(obj)
      })
      this.studyLengthList = [
        [
          { postName: "会计核算岗", rate: 0.48, userName: "李学生290"},
          { postName: "涉税服务岗", rate: 0.24, userName: "李学生290"},
        ],
      ]
      this.studyLengthExtend = {
        tooltip: {
          trigger: 'axis',
          formatter: function(params){
            // let data = that.studyLengthList[params[0].dataIndex]
            // let arr = []
            let userName = that.studyLengthData.rows[params[0].dataIndex].name
            // $.each(data,function(key,value){
            //   let str = '<div style="color: #fff"><span>'+value.postName+'('+value.userName+')：</span>'+Math.ceil(value.rate*100)+'%</div>'
            //   arr.push(str)
            // })
            // let content = arr.join(' ')
            let time = that.studyLengthData.rows[params[0].dataIndex].weights
            let content = '<div style="color: #fff"><span>学习时长：</span>'+time+' min</div>'
            var res;
            res = '<div class="tooltip_hv"><span>'+userName+'</span>'+content+'</div>';
            return res
          }
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value} min'
          },
        },
        series: {
          barMaxWidth: 30,
          label: {
            normal: {
              show: true,
              position: "top",
              formatter: ({ value }) => value + 'min'
            }
          }
        }
      }
      this.studyLengthDataZoom = [
        {
          type: 'slider',
          start: 0,
          end: 100
        }
      ]

      return



      let obj = {
        "classId": this.classId,
        "courseId": this.courseId
      }
      api.getGroupAccuracy(qs.stringify(obj)).then(rs=>{
        if(rs.code==0){
          this.studyLengthData.rows = []
          rs.data.outLayerList.forEach(v=>{
            let obj = {'name':v.teamName,'weights':Math.ceil(v.rate*100)}
            this.studyLengthData.rows.push(obj)
          })
          this.studyLengthList = rs.data.internalList
          let that = this
          this.studyLengthExtend = {
            tooltip: {
              trigger: 'axis',
              formatter: function(params){
                let data = that.studyLengthList[params[0].dataIndex]
                let arr = []
                let userName = that.studyLengthData.rows[params[0].dataIndex].name
                $.each(data,function(key,value){
                  let str = '<div style="color: #fff"><span>'+value.postName+'('+value.userName+')：</span>'+Math.ceil(value.rate*100)+'%</div>'
                  arr.push(str)
                })
                let content = arr.join(' ')
                var res;
                res = '<div class="tooltip_hv"><span>'+userName+'</span>'+content+'</div>';
                return res
              }
            },
            yAxis: {
              type: 'value',
              max: 100,
              axisLabel: {
                formatter: '{value} %'
              },
            },
            series: {
              barMaxWidth: 30,
              label: {
                normal: {
                  show: true,
                  position: "top",
                  formatter: ({ value }) => value + '%'
                }
              }
            }
          }
          this.studyLengthDataZoom = [
            {
              type: 'slider',
              start: 20,
              end: 80
            }
          ]
        }else{
          this.$messageError(rs.msg)
        }
      })
    },
    tabLearnType(){
      if(this.learnType==7){
        this.learnType = 30
      }else{
        this.learnType = 7
      }
      this.getRecentLearningNum()
    },
    getDiscussData(){//班级讨论详情
      api.getDiscussData(this.courseId,this.classId).then(rs=>{
        if(rs.code==0){
          this.discussData = {
            departDegress: rs.data.departDegress,
            reply_comment_num: rs.data.reply_comment_num,
            theme_num: rs.data.theme_num,
            theme_reply_comment_num: rs.data.theme_reply_comment_num,
            teacher_theme_num: rs.data.themeData[0].num,
            student_theme_num: rs.data.themeData[1].num,
            today_theme: rs.data.todayData[0].num,
            today_reply: rs.data.todayData[1].num,
            today_comment: rs.data.todayData[2].num,
          }
        }else{
          this.$messageError(rs.msg)
        }
      })
    },
    getOwnDiscussData(){//个人讨论详情
      api.getOwnDiscussData(this.courseId,this.classId).then(rs=>{
        if(rs.code==0){
          this.personalDiscuss = {
            pubThemeNum: rs.data.pubThemeNum,
            replyDegree: rs.data.replyDegree,
            replyNum: rs.data.replyNum,
            totalReplyNum: rs.data.totalReplyNum,
            departDegree: rs.data.departDegree,
            departNum: rs.data.departNum,
            totalDepartNum: rs.data.totalDepartNum
          }
        }else{
          this.$messageError(rs.msg)
        }
      })
    },
    getNoteData(){//笔记详情
      api.getNoteData(this.courseId,this.classId).then(rs=>{
        if(rs.code==0){
          this.noteData = {
            todayNum: rs.data.todayNum,
            totalNum: rs.data.totalNum
          }
        }else{
          this.$messageError(rs.msg)
        }
      })
    },
    getTestData(){//测验折线图
      let that = this
      api.getTestData(this.courseId,this.classId).then(rs=>{
        if(rs.code==0){
          that.testChartData.rows = []
          that.testDataList = []
          if(rs.data.length>0){
            rs.data.forEach(v=>{
              let obj = {
                '名称': v.paperName,
                '班级最高分': v.maxScore,
                '班级平均分': v.avgScore
              }
              that.testChartData.rows.push(obj)
            })
            if(rs.data.length>1){
              rs.data.forEach(v=>{
                let obj = {
                  'progress': v.progress,
                  'paperName': v.paperName,
                  'studentNum': v.studentNum?v.studentNum:0,
                  'num': v.num?v.num:0
                }
                that.testDataList.push(obj)
              })
            }else{
              this.singleTestData = {
                paperName: rs.data[0].paperName,
                progress: rs.data[0].progress,
                num: rs.data[0].num,
                studentNum: rs.data[0].studentNum,
                maxScore: rs.data[0].maxScore,
                avgScore: rs.data[0].avgScore,
              }
            }
            that.testDataEmpty = false
            that.isTestData = true
          }else{
            that.testDataEmpty = true
            that.isTestData = false
          }
        }else{
          this.$messageError(rs.msg)
        }
      })
    },
    testJump(item){//测验跳转
      console.log(item)
    }
  },
}
</script>
<style lang="scss" scoped>
  .teacher_theory_wrap{
    padding: 16px;
    box-sizing: border-box;
    /deep/ .class_number_statistics{
      height:300px;
      background:rgba(255,255,255,1);
      border-radius:4px;
      margin-bottom: 16px;
      h2{
        font-size:16px;
        font-weight:600;
        line-height:21px;
        color:#333333;
        margin-bottom: 24px;
        padding: 16px 0 0 24px;
        span{
          margin: 10px;
          &:nth-child(1){color:#5397F7;}
          &:nth-child(2){color:#5397F7;}
          &:nth-child(3){color:#FF785A;}
        }
      }
      .class_number_statistics_main{
        display: flex;
        justify-content: center;
        .overall_progress{
          width: 270px;
          text-align: center;
          float: left;
          .el-progress-circle{
            width: 145px !important;
            height: 145px !important;
            margin-top: 12px;
          }
          p{
            font-size:12px;
            font-weight:400;
            line-height:16px;
            color:rgba(51,51,51,1);
            margin-top: 17px;
            span{
              cursor: pointer;
              color: #5397F7;
              i{
                display: inline-block;
                width: 8px;
                height: 8px;
                margin-left: 5px;
                background: url('../../../../../../../static/images/newLoginPage/icon2.png') no-repeat;
                background-size: 100%;
              }
            }
          }
        }
        .classify_progress{
          height:200px;
          border:1px solid rgba(226,226,226,1);
          border-radius:4px;
          float: right;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: space-around;
          margin-left: 20px;
          p{
            text-align: center;
            margin-top: 14px;
          }
          .progress_diagram{
            margin-right: 50px;
            &:first-child{
              margin-left: 50px;
            }
          }
          .el-progress-circle{
            width: 115px !important;
            height: 115px !important;
          }
        }
      }
    }
    .class_number_statistics_single{
      height: 48px;
      background:rgba(255,255,255,1);
      border-radius:4px;
      margin-bottom: 16px;
      position: relative;
      h2{
        font-size:16px;
        font-weight:600;
        line-height:48px;
        color:#333333;
        margin-left: 24px;
        span{
          margin: 10px;
          &:nth-child(1){color:#5397F7;}
          &:nth-child(2){color:#5397F7;}
          &:nth-child(3){color:#FF785A;}
        }
      }
      /deep/ .overall_course_progress{
        width: 57%;
        height: 48px;
        position: absolute;
        left: 395px;
        top: 0;
        span{
          float: left;
          font-size:14px;
          color:rgba(51,51,51,1);
          margin-top: 15px;
        }
        .el-progress__text{
          font-size:12px !important;
          font-weight:400;
          color:rgba(83,151,247,1);
          margin-left: 20px;
        }
      }
      button{
        position: absolute;
        right: 64px;
        top: 9px;
        width:72px;
        height:30px;
        background:rgba(255,255,255,1);
        border:1px solid #5397F7;
        border-radius:4px;
        color: #5397F7;
        padding: 0;
        font-size: 12px;
      }
    }
    .recent_learning_num{
      width:calc(75% - 16px);
      height:334px;
      background:rgba(255,255,255,1);
      border-radius:4px;
      float: left;
      h2{
        font-size:16px;
        font-weight:600;
        line-height:21px;
        color:rgba(51,51,51,1);
        padding: 16px 0 0 24px;
        span{
          font-size:12px;
          font-weight:400;
          line-height:16px;
          color:rgba(153,153,153,1);
          i{
            color: #5397F7;
            margin: 0 5px;
          }
          &:first-child{
            margin-left: 24px;
          }
          &:last-child{
            margin-left: 3px;
          }
        }
      }
      .broken_line_diagram{
        width: 100%;
        height: 300px;
        padding-left: 70px;
        box-sizing: border-box;
        position: relative;
        p{
          position: absolute;
          right: 25px;
          top: -20px;
          padding: 0;
          width: 56px;
          height: 24px;
          display: flex;
          border-radius: 4px;
          border: none;
          overflow: hidden;
          cursor: pointer;
          b{
            display: inline-block;
            width: 28px;
            height: 24px;
            font-weight: 400;
            background: #E8F2FF;
            font-size: 12px;
            line-height: 24px;
            text-align: center;
            color: #5397F7;
          }
          .active{
            background: #5397F7;
            color: #fff;
          }
        }
      }
    }
    /deep/ .learning_hours_today{
      width:25%;
      height:334px;
      background:rgba(255,255,255,1);
      border-radius:4px;
      float: right;
      padding: 0 24px;
      box-sizing: border-box;
      .el-tabs__active-bar{
        background-color: #333;
      }
      .el-tabs__item.is-active{
        color: #333;
        font-weight: 600;
      }
      .prompting_language{
        font-size:12px;
        font-weight:400;
        color:rgba(244,61,61,1);
      }
      .ranking_list{
        margin-top: 24px;
        li{
          height: 40px;
          display: flex;
          align-items: center;
          span{
            &:nth-child(1){
              width: 24px;
              height: 24px;
              img{
                width: 100%;
              }
            }
            &:nth-child(2){
              width:50px;
              font-size:20px;
              font-weight:bold;
              color:rgba(51,51,51,1);
              margin-left: 5px;
            }
            &:nth-child(3){
              width:80px;
              font-size:14px;
              font-weight:400;
              color:rgba(102,102,102,1);
            }
            &:nth-child(4){
              font-size:14px;
              font-weight:400;
              color:rgba(102,102,102,1);
            }
          }
        }
      }
      .view_more{
        text-align: center;
        font-size:12px;
        font-weight:400;
        color:rgba(83,151,247,1);
        margin-top: 13px;
        cursor: pointer;
      }
    }
    .study_length_statistics{
      height:350px;
      background:rgba(255,255,255,1);
      border-radius:4px;
      margin-top: 16px;
      h2{
        font-size:16px;
        font-weight:600;
        // line-height:48px;
        padding-top: 16px;
        color:#333333;
        margin-left: 24px;
      }
      .histogram_statistics{
        padding-left: 3%;
      }
    }
    /deep/ .discuss_statistics{
      height:320px;
      background:rgba(255,255,255,1);
      border-radius:4px;
      margin: 16px 0;
      h2{
        font-size:16px;
        font-weight:600;
        line-height:21px;
        color:rgba(51,51,51,1);
        padding: 16px 0 0 24px;
        margin-bottom: 16px;
      }
      .class_discuss{
        width:60%;
        height:230px;
        background:rgba(255,255,255,1);
        border:1px solid rgba(235,235,235,1);
        border-radius:4px;
        float: left;
        margin-left: 24px;
        .class_discuss_title{
          height: 58px;
          display: flex;
          align-items: center;
          h3{
            font-size:16px;
            font-weight:400;
            color:rgba(51,51,51,1);
            margin-left: 24px;
            span{
              font-size: 12px;
              cursor: pointer;
              color: #5397F7;
              margin-left: 8px;
              i{
                display: inline-block;
                width: 8px;
                height: 8px;
                margin-left: 5px;
                background: url('../../../../../../../static/images/newLoginPage/icon2.png') no-repeat;
                background-size: 100%;
              }
            }
          }
          p{
            font-size:12px;
            font-weight:400;
            color:rgba(51,51,51,1);
            margin-left: 16px;
            span{
              color: #5397F7;
            }
          }
        }
        .class_discuss_progress{
          width: 180px;
          float: left;
          text-align: center;
          p{
            font-size:12px;
            font-weight:400;
            color:rgba(51,51,51,1);
            margin-top: 8px;
          }
        }
        .class_discuss_details{
          width: calc(100% - 185px);
          height: 120px;
          float: right;
          display: flex;
          align-items: center;
          li{
            height:88px;
            background:rgba(255,255,255,1);
            box-shadow:0px 4px 8px rgba(0,0,0,0.14);
            border-radius:4px;
            padding: 17px 0 0 20px;
            box-sizing: border-box;
            &:nth-child(1){
              width: 160px;
              p{
                font-size:12px;
                font-weight:400;
                line-height:16px;
                color:rgba(51,51,51,1);
                span{
                  color: #5397F7;
                  font-size: 28px;
                  position: relative;
                  &::after{
                    content: "";
                    width: 32px;
                    height: 1px;
                    background: #E6E6E6;
                    position: absolute;
                    bottom: 0;
                    left: 0;
                  }
                }
                &:nth-child(2){
                  margin-top: 8px;
                }
              }
            }
            &:nth-child(2){
              width: 240px;
              margin: 0 3%;
              display: flex;
              .lis_left{
                position: relative;
                p{
                  font-size:12px;
                  font-weight:400;
                  line-height:16px;
                  color:rgba(51,51,51,1);
                  span{
                    color: #5397F7;
                    font-size: 28px;
                    position: relative;
                    &::after{
                      content: "";
                      width: 32px;
                      height: 1px;
                      background: #E6E6E6;
                      position: absolute;
                      bottom: 0;
                      left: 0;
                    }
                  }
                  &:nth-child(2){
                    margin-top: 8px;
                  }
                }
                &::after{
                  content: "";
                  width: 1px;
                  height: 22px;
                  background: #E6E6E6;
                  position: absolute;
                  right: -19px;
                  top: 12px;
                  margin: auto;
                }
              }
              .lis_right{
                margin-left: 40px;
                margin-top: 3px;
                p{
                  font-size:12px;
                  font-weight:400;
                  line-height:16px;
                  color:rgba(51,51,51,1);
                  span{
                    color: #5397F7;
                  }
                  &:nth-child(1){
                    position: relative;
                    &::after{
                      content: "";
                      width: 58px;
                      height: 1px;
                      background: #E6E6E6;
                      position: absolute;
                      bottom: -5px;
                      left: 0;
                    }
                  }
                  &:nth-child(2){
                    margin-top: 11px;
                  }
                }
              }
            }
            &:nth-child(3){
              width: 120px;
              p{
                font-size:12px;
                font-weight:400;
                line-height:16px;
                color:rgba(51,51,51,1);
                span{
                  color: #5397F7;
                  font-size: 28px;
                  position: relative;
                  &::after{
                    content: "";
                    width: 32px;
                    height: 1px;
                    background: #E6E6E6;
                    position: absolute;
                    bottom: 0;
                    left: 0;
                  }
                }
                &:nth-child(2){
                  margin-top: 8px;
                }
              }
            }
          }
        }
      }
      .personal_discuss{
        width:calc(40% - 72px);
        height:230px;
        background:rgba(255,255,255,1);
        border:1px solid rgba(235,235,235,1);
        border-radius:4px;
        float: right;
        margin-right: 24px;
        h3{
          font-size:16px;
          font-weight:400;
          color:rgba(51,51,51,1);
          margin: 16px 0 0 24px;
        }
        ul{
          display: flex;
          li{
            &:nth-child(1){
              width:120px;
              height:88px;
              background:rgba(255,255,255,1);
              box-shadow:0px 4px 8px rgba(0,0,0,0.14);
              border-radius:4px;
              padding: 17px 0 0 20px;
              box-sizing: border-box;
              margin: 38px 5% 0 26px;
              p{
                font-size:12px;
                font-weight:400;
                line-height:16px;
                color:rgba(51,51,51,1);
                span{
                  color: #5397F7;
                  font-size: 28px;
                  position: relative;
                  &::after{
                    content: "";
                    width: 32px;
                    height: 1px;
                    background: #E6E6E6;
                    position: absolute;
                    bottom: 0;
                    left: 0;
                  }
                }
                &:nth-child(2){
                  margin-top: 8px;
                }
              }
            }
            &:nth-child(2){
              text-align: center;
              margin-top: 26px;
              p{
                font-size:12px;
                font-weight:400;
                color:rgba(51,51,51,1);
                margin-top: 8px;
              }
            }
            &:nth-child(3){
              text-align: center;
              margin-left: 16px;
              margin-top: 26px;
              p{
                font-size:12px;
                font-weight:400;
                color:rgba(51,51,51,1);
                margin-top: 8px;
              }
            }
            .el-progress-circle{
              width: 115px !important;
              height: 115px !important;
              // margin-top: 12px;
            }
          }
        }
      }
    }
    .last_wrap{
      position: relative;
      display: flex;
      justify-content: space-between;
    }
    .student_open_notes{
      width: 260px;
      height: 100%;
      min-height:360px;
      background:rgba(255,255,255,1);
      border-radius:4px;
      h2{
        font-size:16px;
        font-weight:600;
        line-height:21px;
        color:rgba(51,51,51,1);
        padding: 16px 0 0 24px;
      }
      ul{
        li{
          width:200px;
          height:88px;
          box-shadow:0px 4px 8px rgba(0,0,0,0.14);
          border-radius:4px;
          margin-left: 30px;
          margin-top: 40px;
          position: relative;
          padding-top: 18px;
          box-sizing: border-box;
          &:first-child{
            background: #5397F7;
          }
          &:last-child{
            background: #34D3B0;
          }
          p{
            font-size:12px;
            color:rgba(255,255,255,1);
            margin-left: 20px;
            span{
              font-size: 28px;
              font-weight:600;
              margin-right: 5px;
            }
            &:nth-child(2){
              margin-top: 8px;
            }
          }
          img{
            width: 20px;
            height: 20px;
            position: absolute;
            right: 20px;
            top: 0;
            bottom: 0;
            margin: auto;
            cursor: pointer;
          }
        }
      }
    }
    .test_statistics_wrap{
      width:calc(100% - 276px);
      min-height:360px;
      background:rgba(255,255,255,1);
      border-radius:4px;
      .test_statistics_diagram{
        h2{
          font-size:16px;
          font-weight:600;
          line-height:21px;
          color:rgba(51,51,51,1);
          padding: 16px 0 0 24px;
        }
        .broken_line_diagram{
          padding-left: 30px;
        }
        .single_test_diagram{
          position: relative;
          .view_details{
            font-size: 12px;
            cursor: pointer;
            color: #5397F7;
            margin-left: 8px;
            position: absolute;
            right: 46px;
            top: -15px;
            i{
              display: inline-block;
              width: 8px;
              height: 8px;
              margin-left: 5px;
              background: url('../../../../../../../static/images/newLoginPage/icon2.png') no-repeat;
              background-size: 100%;
            }
          }
          div{
            text-align: center;
            p{
              &:first-child{
                font-size:16px;
                font-weight:400;
                color:rgba(51,51,51,1);
              }
              &:last-child{
                font-size:12px;
                font-weight:400;
                color:rgba(51,51,51,1);
                margin-top: 8px;
                span{
                  color: #5397F7;
                }
              }
            }
          }
          ul{
            display: flex;
            width: 60%;
            justify-content: space-around;
            margin: 30px 20% 0;
            li{
              text-align: center;
              position: relative;
              p{
                font-size:12px;
                font-weight:400;
                color:rgba(51,51,51,1);
                margin-top: 8px;
              }
              .el-progress-circle{
                width: 115px !important;
                height: 115px !important;
              }
              span{
                position: absolute;
                left: 0;
                right: 0;
                top: 27px;
                background: #fff;
                width: 70px;
                height: 70px;
                line-height: 70px;
                margin: auto;
                font-size: 14px;
              }
            }
          }
        }
      }
      .test_statistics_list{
        h2{
          font-size:16px;
          font-weight:600;
          line-height:21px;
          color:rgba(51,51,51,1);
          padding: 16px 0 0 24px;
        }
        ul{
          margin-top: 16px;
          margin-left: 24px;
          display: flex;
          flex-wrap: wrap;
          li{
            width:160px;
            height:80px;
            background:rgba(83,151,247,1);
            border-radius:4px;
            margin-bottom: 20px;
            margin-right: 20px;
            padding-left: 14px;
            box-sizing: border-box;
            position: relative;
            p{
              font-size: 12px;
              color: #fff;
              &:nth-child(1){
                margin-top: 10px;
                margin-bottom: 10px;
              }
              &:nth-child(2){
                width: 100px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              &:nth-child(3){
                margin-top: 10px;
              }
            }
            img{
              width: 16px;
              height: 16px;
              position: absolute;
              right: 12px;
              bottom: 16px;
              cursor: pointer;
            }
          }
        }
      }
    }
    .student_open_notes_transverse{
      height:100px;
      background:rgba(255,255,255,1);
      border-radius:4px;
      display: flex;
      align-items: center;
      h2{
        font-size:16px;
        color:rgba(51,51,51,1);
        margin-left: 24px;
        font-weight: 600;
      }
      ul{
        height:100px;
        display: flex;
        align-items: center;
        li{
          width:320px;
          height:56px;
          box-shadow:0px 4px 8px rgba(0,0,0,0.14);
          border-radius:4px;
          display: flex;
          align-items: center;
          position: relative;
          &:first-child{
            background:#5397F7;
            margin-left: 180px;
          }
          &:last-child{
            background:#34D3B0;
            margin-left: 106px;
          }
          p{
            font-size:12px;
            line-height:16px;
            color:rgba(255,255,255,1);
            position: relative;
            &:nth-child(1){
              span{
                font-size: 28px;
                font-weight: 600;
                margin-left: 48px;
                margin-right: 5px;
              }
            }
            &:nth-child(2){
              margin-left: 47px;
              &::after{
                content: '';
                width: 1px;
                height: 10px;
                position: absolute;
                left: -20px;
                top: 4px;
                background: #fff;
              }
            }
          }
          img{
            width: 20px;
            height: 20px;
            position: absolute;
            top: 18px;
            right: 18px;
            cursor: pointer;
          }
        }
      }
    }
    .no_data{
      text-align: center;
      img{
        width: 100px;
        margin-top: 50px;
      }
      p{
        margin-top: 15px;
        font-size: 14px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/statistics/teacher/teacherTheory.vue